import React, { useEffect, useState } from 'react';
import { Info, User } from 'lucide-react';
import api from '../../api/client';

const RIGHE = [
  ['nome', 'NOME'],
  ['cognome', 'COGNOME'],
  ['email', 'EMAIL'],
  ['telefono', 'TELEFONO'],
  ['codice_fiscale', 'CODICE FISCALE'],
  ['data_nascita', 'DATA DI NASCITA', v => v ? new Date(v).toLocaleDateString('it-IT') : null],
];

export default function IlMioProfilo() {
  const [dati, setDati] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/customers/me').then(r => setDati(r.data)).catch(() => setDati(null)).finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: '640px' }}>
      <div style={{ marginBottom: '20px' }}>
        <h1 style={s.title}>Il mio profilo</h1>
        <p style={s.sub}>I tuoi dati anagrafici registrati nel gestionale.</p>
      </div>

      <div style={s.info}>
        <Info size={14} color="#F4600C" style={{ flexShrink: 0, marginTop: '1px' }} />
        <div>
          Queste informazioni sono state inserite dalla società a partire dai dati di tesseramento (Dink).
          Se noti un errore o un dato mancante, segnalalo allo staff: questa pagina è di sola consultazione,
          le correzioni vanno fatte da loro.
        </div>
      </div>

      {loading && <div style={{ color: 'var(--text-dim)', fontSize: 'var(--font-size-sm)' }}>Caricamento...</div>}

      {!loading && !dati && (
        <div style={s.vuoto}>
          <User size={22} color="#555" />
          <div>Non è stato possibile caricare il profilo. Contatta lo staff.</div>
        </div>
      )}

      {dati && (
        <div style={s.card}>
          {RIGHE.map(([campo, label, fmt], i) => {
            const valore = fmt ? fmt(dati[campo]) : dati[campo];
            return (
              <div key={campo} style={{ ...s.riga, ...(i === RIGHE.length - 1 ? { borderBottom: 'none' } : {}) }}>
                <span style={s.label}>{label}</span>
                <span style={valore ? s.valore : s.valoreVuoto}>{valore || 'non specificato'}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const s = {
  title: { fontFamily: "'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight: '800', letterSpacing: '2px' },
  sub: { color: 'var(--text-dim)', fontSize: 'var(--font-size-sm)', marginTop: '2px' },
  info: { display: 'flex', gap: '10px', background: '#F4600C10', border: '1px solid #F4600C30', borderRadius: '8px', padding: '10px 12px', fontSize: 'var(--font-size-xs)', color: 'var(--text)', lineHeight: '1.6', marginBottom: '20px' },
  vuoto: { display: 'flex', alignItems: 'center', gap: '12px', background: 'var(--bg-input)', border: '1px solid var(--border2)', borderRadius: '10px', padding: '16px', color: 'var(--text-dim)', fontSize: 'var(--font-size-sm)' },
  card: { background: 'var(--bg-input)', border: '1px solid var(--border2)', borderRadius: '12px', padding: '4px 20px' },
  riga: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 0', borderBottom: '1px solid var(--border2)' },
  label: { fontSize: 'var(--font-size-xs)', letterSpacing: '1px', fontWeight: '700', color: '#555' },
  valore: { fontSize: 'var(--font-size-sm)', color: 'var(--text)' },
  valoreVuoto: { fontSize: 'var(--font-size-sm)', color: 'var(--text-dim)', fontStyle: 'italic' },
};
